<template>
  <el-dialog :title="dialogTitle"
             :visible.sync="dialogVisible"
             width="800px"
             :close-on-click-modal="false"
             @close="handleClose"
             class="audit-dialog"
             @open="open()">
    <div class="audit-container">
      <!-- 报录审核（左边） -->
      <div v-if="this.auditType == 1"
           class="enrollment-section">
        <div class="screenshot-container">
          <div class="screenshot-title">报录截图</div>
          <div class="screenshot-wrapper">
            <img v-if="formData.apply_certify_img"
                 :src="formData.apply_certify_img"
                 alt="报录截图"
                 class="screenshot-img" />
            <div v-else
                 class="screenshot-placeholder">
              <i class="el-icon-picture-outline"></i>
              <p>暂无截图</p>
            </div>
          </div>
        </div>

        <div class="form-section">
          <el-form ref="form"
                   :model="formData"
                   label-width="120px"
                   size="small">
            <el-form-item label="姓名">
              <el-input v-model="formData.realname"
                        style="width:215px" />
            </el-form-item>
            <!-- <div class="score-header">
              <span>姓名：{{ formData.realname }}</span>
            </div> -->
            <!-- <el-form-item label="院校">
              <el-select v-model="formData.apply_college_name"
                         filterable
                         placeholder="请选择">
                <el-option v-for="item in options.university"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value" />
              </el-select>
            </el-form-item> -->
            <el-form-item label="院校"
                          prop="college">
              <el-select v-model="formData.apply_college"
                         filterable
                         placeholder="请选择"
                         @change="collegeChange">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="{ value: item.code, label: item.name }">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业"
                          prop="major">
              <el-select v-model="formData.apply_major"
                         placeholder="请选择"
                         filterable
                         clearable
                         @change="majorChange">
                <el-option v-for="(item, index) in majorList"
                           :key="index"
                           :label="`（${item.code}）${item.name}`"
                           :value="{ value: item.code, label: item.name }">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="学院名称："
                          prop="academy">
              <el-select v-model="formData.apply_academy"
                         placeholder="请选择"
                         filterable
                         clearable
                         @change="academyChange">
                <el-option v-for="(item, index) in academylist"
                           :key="index"
                           :label="`（${item.academy_code}）${item.academy_name}`"
                           :value="{
                      value: item.academy_code,
                      label: item.academy_name,
                      directions: item.directions,

                    }">
                  <span>{{
                      `（${item.academy_code}）${item.academy_name}`
                    }}</span>
                </el-option>
                <!-- directions: item.directions, -->

              </el-select>
            </el-form-item>
            <el-form-item label="方向名称："
                          prop="direction">
              <el-select v-model="formData.apply_direction"
                         placeholder="请选择"
                         filterable
                         clearable>
                <el-option v-for="(item, index) in directionlist"
                           :key="index"
                           :label="item.direction"
                           :value="{
                      value: item.direction_code,
                      label: item.direction,
                    }">
                  <span>{{
                      `（${item.direction_code}）${item.direction}`
                    }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学习方式："
                          prop="enrol_type">
              <el-select v-model="formData.apply_enrol_type"
                         filterable
                         placeholder="请选择"
                         clearable>
                <el-option v-for="(item, index) in enrol_types"
                           :key="index"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="状态">
              <el-radio-group v-model="formData.check_status">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">驳回</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="formData.check_status == '2'"
                          label="驳回理由">
              <el-input v-model="formData.refuse_reason"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入驳回理由" />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <!-- 成绩审核（右边） -->
      <div v-else
           class="score-section">
        <div class="screenshot-container">
          <div class="screenshot-title">成绩截图</div>
          <div class="screenshot-wrapper">
            <img v-if="formData.score_certify_img"
                 :src="formData.score_certify_img"
                 alt="成绩截图"
                 class="screenshot-img" />
            <div v-else
                 class="screenshot-placeholder">
              <i class="el-icon-picture-outline"></i>
              <p>暂无截图</p>
            </div>
          </div>
        </div>

        <div class="score-form-section">
          <!-- <div class="score-header">
            <span>姓名：{{ formData.realname }}</span>
          </div> -->

          <div class="form-section">
            <el-form ref="form"
                     :model="formData"
                     label-width="100px"
                     size="small">
              <el-form-item label="姓名">
                <el-input v-model="formData.realname"
                          style="width:215px" />
              </el-form-item>
              <el-form-item label="科目一成绩">
                <el-input v-model="formData.exam_score_politics"
                          style="width:215px" />
              </el-form-item>
              <el-form-item label="科目二成绩">
                <el-input v-model="formData.exam_score_language"
                          style="width:215px" />
              </el-form-item>
              <el-form-item label="科目三成绩">
                <el-input v-model="formData.exam_score_business_1"
                          style="width:215px" />
              </el-form-item>
              <el-form-item label="科目四成绩">
                <el-input v-model="formData.exam_score_business_2"
                          style="width:215px" />
              </el-form-item>
              <el-form-item label="总分">
                <el-input v-model="examScoreTotal"
                          style="width:215px"
                          disabled />
              </el-form-item>
              <el-form-item label="状态">
                <el-radio-group v-model="formData.check_status">
                  <el-radio :label="1">通过</el-radio>
                  <el-radio :label="2">驳回</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="formData.check_status == '2'"
                            label="驳回理由">
                <el-input v-model="formData.refuse_reason"
                          type="textarea"
                          :rows="2"
                          placeholder="请输入驳回理由" />
              </el-form-item>

            </el-form>
          </div>

        </div>
      </div>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button @click="handleConfirm">确认</el-button>
      <el-button type="primary"
                 @click="handleTo">确认并下一个</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
import { amendApplyCheck, getamendApplybyId } from '@/api/adjust'
export default {
  name: 'ApplyCheckDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    dataForm: {
      type: Object,
      default: () => ({}),
    },
    id_array: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      p: 0,
      nocheckList: [],
      dialogVisible: false,
      auditType: 1,
      formData: {},
      majorList: [],
      academylist: [],
      directionlist: [],
      enrol_types: [
        { label: '全日制', value: 1 },
        { label: '非全日制', value: 2 },
      ],
    }
  },
  computed: {
    dialogTitle() {
      return this.auditType == 1 ? '报录审核' : '成绩审核'
    },
    examScoreTotal() {
      console.log('计算属性')
      return (
        (Number(this.formData.exam_score_politics) || 0) +
        (Number(this.formData.exam_score_language) || 0) +
        (Number(this.formData.exam_score_business_1) || 0) +
        (Number(this.formData.exam_score_business_2) || 0)
      )
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dataForm(val) {
      this.auditType = val.amend_type
      this.formData = val
    },
    id_array(val) {
      this.idArray = val
      console.log('当前的id数组', this.idArray)
    },
    examScoreTotal: {
      handler(newVal) {
        this.formData.exam_score_total = newVal
      },
      immediate: true, // 立即执行一次
    },
  },
  methods: {
    open() {
      if (!this.$store.state.collegeList) {
      } else {
        this.$store.dispatch('getAllColleges')
      }
      let data = {
        id: this.formData.id,
      }
      this.detailquest(data)
      setTimeout(() => {
        this.p = this.idArray.map((item) => item).indexOf(this.formData.id)

        this.idArray.splice(this.p, 1)
        this.idArray.unshift(this.formData.id)
      }, 500)
    },

    detailquest(data) {
      this.loading = true
      getamendApplybyId(data).then((res) => {
        this.updateEcho(res)
      })
    },
    //回显数据
    updateEcho(val) {
      this.auditType = val.amend_type
      if (val.amend_type == '1') {
        this.fetchMajor(val.apply_college_code)
        this.fetchMajorInfo(val.apply_college_code, val.apply_major_code)
      }
      this.formData = val
      if (this.formData.status == 0) {
        this.$set(this.formData, 'check_status', 1)
      } else {
        this.$set(this.formData, 'check_status', val.status)
      }

      // this.$set(this.formData, 'apply_college', {
      //   value: val.apply_college_code,
      //   label: val.apply_college_name,
      // })
      this.$set(this.formData, 'apply_college', {
        value: val.apply_college_code,
        label: val.apply_college_name,
      })
      this.$set(this.formData, 'apply_major', {
        value: val.apply_major_code,
        label: val.apply_major_name,
      })
      this.$set(this.formData, 'apply_academy', {
        value: val.apply_academy_code,
        label: val.apply_academy_name,
      })

      this.$set(this.formData, 'apply_direction', {
        value: val.apply_direction_code,
        label: val.apply_direction_name,
      })
    },
    // 通过并继续
    handleTo() {
      console.log('idarray', this.idArray.length)
      if (this.idArray.length == 1) {
        let obj = {
          id: this.idArray[0],
          check_status: this.formData.check_status,
          refuse_reason: this.formData.refuse_reason,
        }
        amendApplyCheck(obj).then((res) => {
          console.log(res, 'shenhejieguo')
          this.$message.success(`审核通过`)

          this.$emit('confirm')
        })

        this.$message.success(`暂时待审核没有数据了`)
        // this.nocheckList = []
        return
      } else {
        let obj = {
          id: this.idArray[0],
          check_status: this.formData.check_status,
          refuse_reason: this.formData.refuse_reason,
        }
        amendApplyCheck(obj).then((res) => {
          this.$message.success(`审核通过请继续下一条`)
          this.idArray.splice(0, 1)
          this.detailquest({
            id: this.idArray[0],
          })
        })
      }
    },
    // 录取院校选择后还要搜索相对应的院校名称
    collegeChange(e) {
      this.fetchMajor(e.value)

      this.$forceUpdate()
    },
    fetchMajor(college_code) {
      collegeMajorList({ college_code, isPaging: 0 }).then((res) => {
        this.majorList = res.list
        // if (this.dataForm.list.length <= 0) {
        //   this.dataForm.list.push({
        //     major: null,
        //     academy: null,
        //     plan_last_count_switch: 1,
        //     plan_last_count: '有',
        //   })
        // }
      })
    },

    majorChange(e) {
      this.fetchMajorInfo(this.dataForm.college.value, e.value)
    },
    fetchMajorInfo(college_code, major_code) {
      majorinfo({ college_code, major_code, isPaging: 0 }).then((res) => {
        this.academylist = res.academys
        const academy = this.academylist.find(
          (item) => item.academy_code === this.formData.apply_academy_code
        )
        if (academy) {
          this.directionlist = academy.directions
        }
      })
    },
    academyChange(e) {
      this.directionlist = e.directions
    },
    fetchAcademy(college_code, major_code) {
      academyList({ college_code, major_code, isPaging: 0 }).then((res) => {
        this.academylist = res.list
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('close')
    },

    handleConfirm() {
      if (!this.formData.check_status) {
        this.$message.error('请选择状态')

        return
      }
      if (this.formData.id) {
        let obj = {
          id: this.idArray[0],
          check_status: this.formData.check_status,
          refuse_reason: this.formData.refuse_reason,
        }
        amendApplyCheck(obj).then((res) => {
          console.log(res, 'shenhejieguo')
          this.$emit('confirm')
        })
      } else {
        console.log('无id')
      }
      // this.handleClose()
    },

    handleConfirmAndNext() {
      this.$emit('confirm-and-next', this.formData)
      this.handleClose()
    },
  },
}
</script>

<style scoped>
.audit-container {
  display: flex;
  gap: 20px;
  height: 600px;
}

/* 报录审核样式 */
.enrollment-section {
  display: flex;
  gap: 20px;
  width: 100%;
}

/* 成绩审核样式 */
.score-section {
  display: flex;
  gap: 20px;
  width: 100%;
}

.screenshot-container {
  flex: 0 0 300px;
  display: flex;
  flex-direction: column;
}

.screenshot-title {
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.screenshot-wrapper {
  flex: 1;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.screenshot-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.screenshot-placeholder {
  text-align: center;
  color: #999;
  padding: 40px;
}

.screenshot-placeholder i {
  font-size: 48px;
  margin-bottom: 10px;
}

/* 报录表单 */
.form-section {
  flex: 1;
  overflow-y: auto;
  padding-right: 10px;
}

.form-section .el-form-item {
  margin-bottom: 16px;
}

/* 成绩表单 */
.score-form-section {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.score-header {
  margin-bottom: 15px;
  padding: 8px 0;
  font-weight: bold;
  border-bottom: 1px solid #e6e6e6;
}

.score-list {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  padding-right: 10px;
}

.score-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.score-label {
  width: 70px;
  text-align: right;
  font-size: 12px;
  color: #666;
}

/* 滚动条样式 */
.form-section::-webkit-scrollbar,
.score-list::-webkit-scrollbar {
  width: 6px;
}

.form-section::-webkit-scrollbar-track,
.score-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.form-section::-webkit-scrollbar-thumb,
.score-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.form-section::-webkit-scrollbar-thumb:hover,
.score-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>